import { effect, inject, Service } from '@angular/core';
import { Router } from '@angular/router';
import { UserRegistrationStep } from '@workspace/data-types';
import { AuthStore, UserRegistrationStore } from '../ngrx';

@Service()
export class UserStateService {
  private readonly router = inject(Router);
  private readonly authStore = inject(AuthStore);
  private readonly userRegistrationStore = inject(UserRegistrationStore);

  readonly isAuthenticated = this.authStore.isAuthenticated();
  readonly currentUserRegistration = this.userRegistrationStore.currentUserRegistration();

  redirectAccordingly(): void {
    if (!this.isAuthenticated) {
      void this.router.navigate(['/auth/sign-in']);
      return;
    }

    if (this.authStore.isUserAuthenticated()) {
      void this.router.navigate(['/']);
      return;
    }

    if (
      this.authStore.isUserRegistrationAuthenticated() &&
      this.currentUserRegistration?.step !== UserRegistrationStep.COMPLETED
    ) {
      void this.router.navigate([`/landing/user-registration/steps/${this.currentUserRegistration?.step}`]);
      return;
    }
  }

  async waitForInitialization(): Promise<void> {
    return new Promise<void>((resolve) => {
      const ref = effect(() => {
        if (this.authStore.isInitialized()) {
          ref.destroy();
          resolve();
        }
      });
    });
  }
}
